import React from 'react';

import { BillingCycleEnum, type CouponStatus, type Plan } from 'js/src/client';
import { PrimaryButton, TertiaryButton } from 'js/src/components/common/ui/Button';
import Modal from 'js/src/components/common/ui/modal';
import type { ConfirmationModalData } from 'js/src/components/pricing/types';

type Props = {
    showing?: boolean;
    update_subscription: (email: string, plan: Plan) => void;
    close_subscription_change_modal?: VoidFunction;
    subscription_data: ConfirmationModalData;
    coupon_data: CouponStatus | null;
};

const SubscriptionChangeModal = ({
    showing = false,
    update_subscription,
    close_subscription_change_modal,
    subscription_data,
    coupon_data,
}: Props) => {
    const plan = subscription_data.plan;
    const email = subscription_data.email;
    const is_coupon_valid = coupon_data?.valid;

    const confirm_subscription_change = (e: React.MouseEvent) => {
        e.stopPropagation();
        e.preventDefault();
        update_subscription(email, plan);
    };

    return (
        <Modal
            showing={showing}
            title="Change plans"
            className="change-plans"
            onHidden={close_subscription_change_modal}
        >
            <div className="row mb-l5-8">
                <div className="col-sm-12">
                    <b>Switch to {plan.display_name}</b>
                    <ul>
                        <li>
                            Billed&nbsp;
                            {plan.billing_cycle === BillingCycleEnum.MONTHLY
                                ? 'monthly'
                                : 'annually'}
                        </li>
                        <li>
                            ${plan.price}/
                            {plan.billing_cycle === BillingCycleEnum.MONTHLY ? 'month' : 'year'}
                        </li>
                    </ul>
                </div>
            </div>
            {is_coupon_valid && ( // show coupon if coupon is applied.
                <div className="row mb-l5-8">
                    <div className="col-sm-12">
                        <b>Coupon</b>
                        <ul>
                            <li>Code: {coupon_data.id}</li>
                            <li>
                                {coupon_data.discount} off {coupon_data.duration}
                            </li>
                        </ul>
                    </div>
                </div>
            )}
            <div className="row mb-l5-8">
                <div className="col-sm-12">
                    <h5 className="fw-bold">Total: ${plan.price} USD </h5>
                </div>
            </div>
            <div className="modal-button-footer">
                <TertiaryButton onClick={close_subscription_change_modal} text="Cancel" />
                <PrimaryButton onClick={confirm_subscription_change} text="Confirm plan change" />
            </div>
        </Modal>
    );
};

export default SubscriptionChangeModal;
